const calcWidth = (
  containerWidth: number,
  percentWidth: string | number
): number => {
  const widthNum = safeParseFloat(percentWidth);
  const width = containerWidth * (widthNum / 100);
  return width;
};

const safeParseFloat = (value: string | number) => {
  if (typeof value === "string") {
    return parseFloat(value);
  }
  return value;
};

export default calcWidth;
